/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
GOOGLE_processor_version: 294144208
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei/useGLTF'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/models/Seesaw/seasaw.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-0.05, -0.04, 0.02]}>
        <group position={[0.05, 0.04, -0.02]}>
          <mesh material={materials.lambert2SG} geometry={nodes['buffer-0-mesh-0'].geometry} />
          <mesh material={materials.initialShadingGroup} geometry={nodes['buffer-0-mesh-0_1'].geometry} />
          <mesh material={materials.lambert5SG} geometry={nodes['buffer-0-mesh-0_2'].geometry} />
          <mesh material={materials.lambert3SG} geometry={nodes['buffer-0-mesh-0_3'].geometry} />
          <mesh material={materials.lambert4SG} geometry={nodes['buffer-0-mesh-0_4'].geometry} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Seesaw/seasaw.gltf')
